const isDev = process.env.NODE_ENV === "development";

export const getUrl = (name) => {
    if (isDev) {
        return `http://localhost:3000/${name}.html`;
    }

    const source = new URL(location.href);
    const cid = source.searchParams.get("cid");
    const target = new URL(`https://91rushgames.com/91rushgames/${name}.html`);
    target.searchParams.set("cid", cid);
    return target.href;
};

export const getHref = (name, path) => {
    const target = new URL(
        `https://91rushgames.com/91rushgames/${path}/${name}/index.html`
    );
    return target.href;
};
